import styled from "@emotion/styled";
import { Container, Grid } from "@mui/material";
import React from "react";
import { P, SectionHeading, SectionWrapper } from "../../../Styles/style";

import IncognitomodeInWallwt from "../../../../assets/images/IncognitomodeInWallwt.png";
import { useTheme } from "@emotion/react";

const MainGrid = styled(Grid)`
  padding: 80px 0 30px;
  justify-content: center;
  text-align: LEFT;
`;
const GridImg = styled(Grid)`
  text-align-last: right;
  @media screen and (max-width: 599px) {
    text-align-last: unset;
    padding: 20px 0;
  }
`;
const GridText = styled(Grid)`
  padding: 80px 0 0;
`;
const LearnBuutt = styled.a`
  border: 1px solid ${(props) => props.theme.textPrimary};
  color: ${(props) => props.theme.textPrimary};
  padding: 7px 20px;
  text-decoration: none;
`;
const MetAMskimg = styled.img`
  width: 100%;
  max-width: 350px;
`;
const S5_SSS = () => {
  const theme = useTheme();
  return (
    <div>
      <SectionWrapper bgcolor={theme.bgQuaternary} p="4rem 0" id="features">
        <Container maxWidth="xl">
          <MainGrid container rowGap={2}>
            <GridText
              item
              xs={12}
              md={5}
              data-aos="fade-up"
              data-aos-anchor-placement="top-bottom"
              data-aos-delay="300"
              data-aos-offset="0"
              data-aos-duration="1000"
            >
              <SectionHeading
                data-aos="zoom-in"
                data-aos-easing="ease-in"
                data-aos-delay="300"
                data-aos-offset="0"
                data-aos-duration="1000"
              >
                Instant In-Wallet Swap
              </SectionHeading>
              {/* <P
                p="5px 0 10px"
                m="0"
                data-aos="zoom-in"
                data-aos-easing="ease-in"
                data-aos-delay="700"
                data-aos-offset="0"
                data-aos-duration="300"
              >
                <b>
                  Stay In Wallet And Swap Instantly On Ethereum, BNB Chain,
                  Polygon And Avalanch C-Chain
                </b>
              </P> */}
              <P
                data-aos="zoom-in"
                data-aos-easing="ease-in"
                data-aos-delay="300"
                data-aos-offset="0"
                data-aos-duration="1000"
              >
                With the Instant In-Wallet Swap, you can seamlessly swap
                cryptocurrencies while keeping your assets in your wallet. No
                need to send funds to external exchanges – trade instantly on
                multiple blockchains.
              </P>
              <LearnBuutt
                href="#"
                target="blank"
                data-aos="zoom-in"
                data-aos-easing="ease-in"
                data-aos-delay="800"
                data-aos-offset="0"
                data-aos-duration="1000"
              >
                Learn More
              </LearnBuutt>
            </GridText>

            {/* <Grid item xs={2} /> */}
            <GridImg
              item
              xs={12}
              md={5}
              data-aos="zoom-in"
              data-aos-easing="ease-in"
              data-aos-delay="300"
              data-aos-offset="0"
              data-aos-duration="1000"
            >
              <MetAMskimg src={IncognitomodeInWallwt} />
            </GridImg>
          </MainGrid>
        </Container>
      </SectionWrapper>
    </div>
  );
};

export default S5_SSS;
